import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Speaker } from 'lucide-react';
import { LegalLinks } from '../legal/LegalLinks';

export default function AuthLayout() {
  const { user, isDJ, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark">
        <div className="animate-pulse">
          <Speaker className="w-12 h-12 text-primary" />
        </div>
      </div>
    );
  }

  if (user && isDJ) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col bg-background-light dark:bg-background-dark">
      {/* Header */}
      <header className="p-6">
        <div className="flex items-center gap-2">
          <Speaker className="w-8 h-8 text-primary" />
          <span className="text-xl font-bold text-gray-900 dark:text-white">VoteBeats</span>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="p-6 text-center text-sm text-gray-500 dark:text-gray-400">
        &copy; {new Date().getFullYear()} VoteBeats. All rights reserved.
        <LegalLinks className="mt-2" />
      </footer>
    </div>
  );
}
